var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9534 5.11867C17.689 3.72573 14.0613 0.166992 9.99888 0.166992C5.93642 0.166992 2.31197 3.72573 1.04753 5.11867C0.7615 5.43127 0.7615 5.89966 1.04753 6.21531C2.31197 7.60826 5.93958 11.167 9.99888 11.167C14.0582 11.167 17.689 7.60826 18.9534 6.21531C19.2373 5.89966 19.2373 5.43127 18.9534 5.11867ZM9.99888 9.77099C7.65259 9.77099 5.74644 7.929 5.74644 5.66546C5.74644 3.40193 7.65259 1.55994 9.99888 1.55994C12.3452 1.55994 14.2545 3.40193 14.2545 5.66546C14.2545 7.929 12.3452 9.77099 9.99888 9.77099Z",
    fill: "#FFE5B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99974 3.61369C8.82712 3.61369 7.87193 4.53417 7.87193 5.66645C7.87193 6.79873 8.82606 7.71921 9.99974 7.71921C11.1734 7.71921 12.1275 6.79873 12.1275 5.66645C12.1275 4.53417 11.1734 3.61369 9.99974 3.61369Z",
    fill: "#FFE5B7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.cb645ebed714c0a15e3de167c4355467.svg";
export { ForwardRef as ReactComponent };